export const showLockOverlay = (showSpinner: boolean, message: string) => {
    return (dispatch: any) => {
        dispatch({
            type: "SHOW_LOCK_OVERLAY",
            payload: {
                message: message || "",
                showSpinner: showSpinner || false,
            },
        });
    };
};

export const hideLockOverlay = () => {
    return (dispatch: any) => {
        dispatch({
            type: "HIDE_LOCK_OVERLAY",
        });
    };
};

export const showNotificationOverflow = (
    title?: string,
    message?: string,
    type?: "success" | "info" | "error" | "warning",
    duration?: number,
) => {
    return (dispatch: any) => {
        dispatch({
            type: "SHOW_NOTIFICATION_OVERFLOW",
            payload: {
                title: title || "",
                message: message || "",
                type: type || "info",
                duration: duration || 5000,
            },
        });
    };
};

export const hideNotificationOverflow = () => {
    return (dispatch: any) => {
        dispatch({
            type: "HIDE_NOTIFICATION_OVERFLOW",
        });
    };
};
